import React, { Component } from "react";


import AuthService from "../services/LoginService";

import { withRouter } from '../common/with-router';


const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                This field is required!
            </div>
        );
    }
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);

        this.state = {
            username: "",
            password: "",
            loading: false,
            message: ""
        };
    }

    onChangeUsername(e) {
        this.setState({
            username: e.target.value
        });
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    handleLogin(e) {
        e.preventDefault();

        this.setState({
            message: "",
            loading: true
        });

        //this.form.validateAll();

       // if (this.checkBtn.context._errors.length === 0) {
        const data = {
            usernameOrEmail: this.state.username,
            password: this.state.password
        };

        AuthService.login(JSON.stringify(data)).then(
                () => {
                    this.props.router.navigate("/");
                    window.location.reload();
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        loading: false,
                        message: resMessage
                    });
                }
            );
       /* } else {
            this.setState({
                loading: false
            });
        }*/
    }

    render() {
       
        return (
            <div className="col-md-12">
                <div className="card card-container">
                <h1>Please Log In</h1>

                <img
                    src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                    alt="profile-img"
                    className="profile-img-card"
                />
                <form
                    ref={c => {
                        this.form = c;
                    }}
                    onSubmit={this.handleLogin}>
                    
                   
                    <div className="form-group">
                        <label htmlFor="username">Username Or Email</label>
                            <input type="text"
                                className="form-control"
                            onChange={this.onChangeUsername}
                            name="username"
                            value={this.state.username}
                            validations={[required]}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input type="password"
                            className="form-control"
                            name="password"
                            value={this.state.password}
                            onChange={this.onChangePassword}
                            validations={[required]}
                        />
                    </div>
                    <br/>
                    <div className="form-group">
                        <button
                            className="btn btn-primary btn-block"
                            disabled={this.state.loading}
                        >
                            {this.state.loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                            <span>Login</span>
                        </button>
                    </div>

                    {this.state.message && (
                        <div className="form-group">
                            <div className="alert alert-danger" role="alert">
                                {this.state.message}
                            </div>
                        </div>
                    )}

                      


                </form>
            </div>
            </div >
        );
    }
}

export default withRouter(Login);